import { Form, Input, Typography } from 'antd';
import React from 'react';
import {
  FormStempContentProps,
  contentStyling,
} from '../../constants/constants';

export const Block7 = React.memo(
  ({ form, currentStep }: FormStempContentProps) => {
    return (
      <div
        style={{
          ...contentStyling,
          display: currentStep === 11 ? 'block' : 'none',
        }}
      >
        <Typography.Title
          style={{ marginTop: 0, marginBottom: 34, fontWeight: 'normal' }}
          level={4}
        >
          Pastabos, komentarai
        </Typography.Title>
        <Form.Item name={['subject', 'block7', 'comments']}>
          <Input.TextArea rows={2} />
        </Form.Item>
      </div>
    );
  },
);
